import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { ReactNode } from 'react';
import { Route } from 'react-router-dom';
import BikeleasingContractDetailsPage from '../../page/bikeleasingV2/BikeleasingContractDetailsPage';
import BikeleasingContractsPage from '../../page/bikeleasingV2/BikeleasingContractsPage';
import { BikeleasingEmployeesPage } from '../../page/bikeleasingV2/BikeleasingEmployeesPage';
import { BikeleasingInformationPage } from '../../page/bikeleasingV2/BikeleasingInformationPage';
import BikeleasingInsurancePage from '../../page/bikeleasingV2/BikeleasingInsurancePage';
import BikeleasingNewsDetailsPage from '../../page/bikeleasingV2/BikeleasingNewsDetailsPage';
import BikeleasingNewsListPage from '../../page/bikeleasingV2/BikeleasingNewsListPage';
import BikeleasingSettingsPage from '../../page/bikeleasingV2/BikeleasingSettingsPage';
import { RoutesExtensionInterface } from '../interface/routes.extension.interface';

export class BikeleasingRoutesExtension extends RoutesExtensionInterface {
  get privateRoutes(): ReactNode {
    const benefit = BenefitDTOBenefitEnum.BikeleasingV2.toLowerCase();

    return (
      <>
        <Route path={`/benefits/${benefit}`} element={<BikeleasingEmployeesPage />} />
        <Route path={`/benefits/${benefit}/contracts`} element={<BikeleasingContractsPage />} />
        <Route path={`/benefits/${benefit}/contracts/:contractId`} element={<BikeleasingContractDetailsPage />} />
        <Route path={`/benefits/${benefit}/insurances`} element={<BikeleasingInsurancePage />} />
        <Route path={`/benefits/${benefit}/settings`} element={<BikeleasingSettingsPage />} />
        <Route path={`/benefits/${benefit}/information`} element={<BikeleasingInformationPage />} />
        <Route path={`/benefits/${benefit}/articles`} element={<BikeleasingNewsListPage />} />
        <Route path={`/benefits/${benefit}/articles/:articleId`} element={<BikeleasingNewsDetailsPage />} />
      </>
    );
  }
}
